/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Select_Folder_TitleInputs */

const en_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - Select Folder`)
};

const fr_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - Selectionner un dossier`)
};

const de_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies – Ordner auswählen`)
};

const it_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - Seleziona cartella`)
};

const ru_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - Выберите папку`)
};

const es_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - Seleccionar carpeta`)
};

const zh_cn2_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - 选择文件夹`)
};

const ja_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies - フォルダを選択`)
};

const hi_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रैस्टिक टेक्नोलॉजीज - फ़ोल्डर चुनें`)
};

const pt_pt2_drastic_tech_select_folder_title = /** @type {(inputs: Drastic_Tech_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias drásticas - Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Drastic Technologies - Select Folder" |
*
* @param {Drastic_Tech_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_select_folder_title = /** @type {((inputs?: Drastic_Tech_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_select_folder_title(inputs)
	if (locale === "de") return de_drastic_tech_select_folder_title(inputs)
	if (locale === "it") return it_drastic_tech_select_folder_title(inputs)
	if (locale === "ru") return ru_drastic_tech_select_folder_title(inputs)
	if (locale === "es") return es_drastic_tech_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_select_folder_title(inputs)
	if (locale === "ja") return ja_drastic_tech_select_folder_title(inputs)
	if (locale === "hi") return hi_drastic_tech_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_select_folder_title(inputs)
	return en_drastic_tech_select_folder_title(inputs)
});